import { makeAssistantToolUI } from '@assistant-ui/react';
import { ToolCallCard } from './tool-call-card';
import { SubAgentSpawnCard } from './subagent-spawn-card';
import { SubAgentRunCard } from './subagent-run-card';

export const SubAgentSpawnToolUI = makeAssistantToolUI<Record<string, unknown>, unknown>({
  toolName: '__subagent_spawn',
  render: ({ args, result }) => (
    <SubAgentSpawnCard args={args} result={result} />
  ),
});

export const SubAgentRunToolUI = makeAssistantToolUI<Record<string, unknown>, unknown>({
  toolName: '__subagent_run',
  render: ({ args, result, isError }) => (
    <SubAgentRunCard args={args} result={result} isError={isError} />
  ),
});

const ToolUI = makeAssistantToolUI<Record<string, unknown>, unknown>({
  toolName: '*',
  render: ({ toolName, toolCallId, args, result, isError, status }) => (
    <ToolCallCard
      toolName={toolName}
      toolCallId={toolCallId}
      args={args}
      result={result}
      isError={isError}
      status={status}
    />
  ),
});

export default ToolUI;
